import { AnySourceStream, Stream } from '../stream'
import { All } from './all'
import { Flatten, flattenObjectValues } from './flatten-object-values'

type UnpackedArray<A> = A extends Array<infer V> ? V : never

const flatArrayObjectMap = <I, O extends object>(source: AnySourceStream<I[]>, mapper: (value: I) => O) => {
    // TODO, this need to be optimized, since flattenObjectValues(mapper(value)) is probably not changing a lot
    return source.flatMap((list) => new All(list.map((value) => flattenObjectValues(mapper(value)))))
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        flatArrayObjectMap<T extends object>(
            mapper: (value: UnpackedArray<DV>) => T
        ): Stream<DV, DE, DC, Flatten<T>[], DE, DC>
    }
}

Stream.prototype.flatArrayObjectMap = function <I, E, C, O extends object>(
    this: AnySourceStream<I[], E, C>,
    mapper: (value: I) => O
) {
    return flatArrayObjectMap(this, mapper) // tslint:disable-line:no-invalid-this
}
